/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown> }} Partner_Billing_Customers_AllInputs */



/**
* | output |
* | --- |
* | "of your {total} customers, ever" |
*
* @param {Partner_Billing_Customers_AllInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_customers_all = /** @type {((inputs: Partner_Billing_Customers_AllInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Customers_AllInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`von Ihren ${i?.total} Kunden, insgesamt`)
	return /** @type {LocalizedString} */ (`of your ${i?.total} customers, ever`)
});